import VerifyBtn from '@/components/VerifyBtn/VerifyBtn';
import { mapGetters } from 'vuex';
import { accountManagementApi } from '@/api/user/accountManagementApi';
import { getErrorLabelMixin } from '@/common/mixin/getErrorLabel';
import { getterTypes } from '@/store/getter-types';
import TextFieldComponent from '@/components/Form/TextField';

export default {
  name: 'PhoneBind',
  mixins: [getErrorLabelMixin],
  data() {
    return {
      form: {
        // countryCode: '',
        // emailCode: '',
        // ga_code: '',
        phoneCode: '',
        mobile: '',
        otp: '',
        // validateCode: '',
        // newMobilePhone: '', // 修改手机号时才需要使用
        // oldValidateCode: '', // 修改手机号时才需要使用
        // isModify: false, // 给校验器用，不用传递给后台
        displayPhone: '',
      },
      phoneValid: true,
      isUpdate: false,
      committing: false,
      rules: {
        otp: {
          required: true,
          numeric: true,
          length: 6,
        },
        mobileNo: {
          required: true,
        }
      }
    };
  },
  methods: {
    validatePhone(event) {
      // if (!event) {
      //   this.phoneValid = false;
      // } else {
      //   this.phoneValid = event.valid;
      // }
    },
    async submitBtnClick() {
      let validated = await this.$refs.validate.validate();
      if (!validated || !this.phoneValid) {
        return;
      }

      this.committing = true;
      let data = {
        ...this.form,
      };

      // console.log(data);
      // data.countryCode = '+' + data.countryCode;
      // delete data.isModify;
      delete data.displayPhone;
      if (this.Getter_User_Info.mobileStatus === 1) {
        // delete data.emailCode;
        // delete data.mobile;
        this._requestModifyMobile(data);
      } else {
        // delete data.newMobilePhone;
        // delete data.oldValidateCode;
        this._requestBindMobile(data);
      }
    },
    // 发送手机验证码条件
    sendPhoneValidCondition() {
      // this.$v.form.mobile.$touch();
      // return !this.$v.form.mobile.$error;
      return;
    },
    // 提交绑定手机号数据
    _requestBindMobile(data) {
      accountManagementApi.bindMobile(data)
        .then(() => {
          this.committing = false;
          this.successNotify(this.$t('success.phone.bind'));
          this.$router.push('/usercenter/account-management');
        })
        .catch(() => {
          this.committing = false;
        });
    },
    // 提交修改手机号数据
    _requestModifyMobile(data) {
      accountManagementApi.modifyMobile(data)
        .then(() => {
          this.committing = false;
          this.successNotify(this.$t('success.phone.unbind'));
          this.$router.push('/usercenter/account-management');
        })
        .catch(() => {
          this.committing = false;
        });
    },
    onInputPhone(formattedNumber, { number, valid, country }) {
      this.form.phoneCode = '+' + country.dialCode;
      this.form.mobile = number.significant;
      this.phoneValid = valid;
    },
  },
  computed: {
    ...mapGetters([getterTypes.Getter_User_Info]),
    errorMsgs() {
      return {
        // countryCode: {
        //   required: ' ',
        // },
        // emailCode: {
        //   requiredUnless: '请输入邮箱验证码',
        //   verifyCode: '邮箱验证码格式不正确',
        // },
        mobile: {
          required: this.$t('v.common.mobile.required'),
          phoneValid: this.$t('v.common.mobile.format'),
        },
        displayPhone: {
          required: this.$t('v.common.mobile.required'),
        },
        otp: {
          required: this.$t('v.common.otp.required'),
          verifyCode: this.$t('v.common.otp.verifyCode'),
        },
        // validateCode: {
        //   required: '请输入手机验证码',
        //   verifyCode: '手机验证码格式不正确',
        // },
        // ga_code: {
        //   required: '请输入谷歌验证码',
        //   gaCode: '谷歌验证码格式不正确',
        // },
        newMobilePhone: {
          requiredIf: this.$t('v.common.newMobile.required'),
          phoneValid: this.$t('v.common.mobile.format'),
          // not: '新手机号与旧手机号不能一致',
          notSame: this.$t('v.common.newMobile.cannot.same'),
        },
        // oldValidateCode: {
        //   requiredIf: '请输入旧手机验证码',
        //   verifyCode: '手机验证码格式不正确',
        // },
      };
    },
  },
  components: {
    VerifyBtn,
    TextFieldComponent
  },
  watch: {
    Getter_User_Info(newval) {
      if (newval.mobileStatus === 1) {
        // this.isUpdate = true;
        // this.form.isModify = true;
        // this.form.mobile = newval.mobile;
      }
    },
  },
  mounted() {
    // let userInfo = this.Getter_User_Info;
    // if (isUpdate && isUpdate === 1) {
    //   this.isUpdate = true;
    //   this.form.isModify = true;
    // } else {
    //   if (userInfo.id && userInfo.mobileStatus === 1) {
    //     this.isUpdate = true;
    //     this.form.isModify = true;
    //     this.form.mobile = userInfo.mobile;
    //   }
    // }
  },
};
